import api from '@/store/api';
//#region : Toast Handling :
/**
 * Shows a toast message.
 * @param {Object} context - The context object containing state and commit function.
 * @param {string} message - The message to be displayed in the toast.
 */
const showToast = ({ state, commit }, message) => {
  if (state.toast.show) commit('hideToast');

  setTimeout(() => {
    commit('showToast', {
      color: 'black',
      message,
      timeout: 3000
    });
  });
};

/**
 * Shows an error toast message.
 * @param {Object} context - The Vuex context object.
 * @param {Error} error - The error object to display.
 */
const showError = ({ state, commit }, error) => {
  if (state.toast.show) commit('hideToast');

  setTimeout(() => {
    commit('showToast', {
      color: 'error',
      message: error.toString(),
      timeout: 10000
    });
  });
};

/**
 * Shows a success toast message.
 * @param {Object} context - The Vuex context object.
 * @param {string} message - The success message to display.
 */
const showSuccess = ({ state, commit }, message) => {
  if (state.toast.show) commit('hideToast');

  setTimeout(() => {
    commit('showToast', {
      color: 'success',
      message,
      timeout: 3000
    });
  });
};
//#endregion

//#region : Authentication :
/**
 * Logs in user based on input credentials
 * @param {*} param0
 * @param {*} payload
 * @returns
 */
const login = ({ dispatch, commit }, payload) => {
  commit('setAuthenticating', true);

  const url = '/user/login';
  const params = {
    email: payload.email,
    password: payload.password,
    rememberMe: payload.rememberMe
  };

  return api
    .post(url, params)
    .then(() => {
      commit('setAuthenticating', false);
      commit('setShowLoginDialog', false);
      dispatch('getUser');
    })
    .catch((error) => {
      commit('setAuthenticating', false);
      throw error;
    });
};
/**
 * Logs out the currently signed in user
 * @param {*} param0
 * @returns
 */
const logout = ({ dispatch, commit }) => {
  commit('setAuthenticating', true);

  const url = '/user/logout';
  const params = {};

  return api.post(url, params).then(() => {
    commit('setAuthenticating', false);
    dispatch('getUser');
  });
};
/**
 * Gets the currently signed in user from the API
 * @param {*} param0
 * @returns
 */
const getUser = ({ dispatch, commit }) => {
  commit('setAuthenticating', true);

  const url = '/user/currentUser';
  const params = {};

  return api.post(url, params).then((response) => {
    commit('setAuthenticating', false);
    commit('setUser', response.data);
    //dispatch('configurator/getProjects', null, { root: true });
  });
};
const register = ({ dispatch, commit }, payload) => {
  commit('setAuthenticating', true);

  const url = '/user/register';
  const params = {
    email: payload.email,
    password: payload.password
  };

  return api
    .post(url, params)
    .then(() => {
      commit('setAuthenticating', false);
      commit('setShowLoginDialog', false);
      dispatch('getUser');
    })
    .catch((error) => {
      commit('setAuthenticating', false);
      throw error;
    });
};

//#endregion

export default {
  showToast,
  showError,
  showSuccess,
  login,
  logout,
  getUser,
  register
};
